import { MeUserDto } from '@interfaces/models';
import { create } from 'zustand';

export interface UserStore {
  updateCompanyName: (companyId: string, companyName: string) => void;
  setUser: (user: MeUserDto | null) => void;
  updateUser: (user: Partial<MeUserDto>) => void;
  user: MeUserDto | null;
}

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  setUser: (user) => set({ user }),

  updateUser: (user) =>
    set((state) => {
      if (!state.user) return { ...state, user: user as MeUserDto };
      return { ...state, user: { ...state.user, ...user } };
    }),

  updateCompanyName: (companyId, companyName) =>
    set((state) => {
      if (!state.user) return state;
      return {
        ...state,
        user: {
          ...state.user,
          companies: state.user.companies.map((c) =>
            c.id === companyId ? { ...c, name: companyName } : c,
          ),
        },
      };
    }),
}));
